import React, { Suspense, useState, useEffect, lazy } from 'react';
import { useMfeOptions } from 'src/contexts/MfeOptionsContext';
import { LoadingScreen } from '../LoadingScreen';
import { Logger } from 'src/utils/Logger';
import { SIMPLEUI_EVENT_MAP } from 'src/constants/SimpleUIEvents';

export const CustomError = () => {
  const {
    options: { errorMfeAssetReference }
  } = useMfeOptions();

  const [CustomErrorMFE, setCustomErrorMFE] =
    useState<React.LazyExoticComponent<any> | null>(null);

  useEffect(() => {
    Logger.log('CustomError MFE started');

    if (errorMfeAssetReference) {
      const LazyComponent = lazy(() =>
        System.import(errorMfeAssetReference).then((module) => ({
          default: module.default
        }))
      );
      setCustomErrorMFE(() => LazyComponent);
    }
  }, [errorMfeAssetReference]);

  return (
    <Suspense
      fallback={
        <LoadingScreen
          flow={SIMPLEUI_EVENT_MAP.LOADING_SPINNER.PRE_CUSTOM_ERROR}
        />
      }
    >
      {CustomErrorMFE ? (
        <CustomErrorMFE
          preventReload={true}
          fullscreen={true}
        />
      ) : null}
    </Suspense>
  );
};
